import * as lodash from 'lodash';
import { IConversionConfig, ISegmentConfigData } from './type';

export const hydrateFormData = (data: IConversionConfig): ISegmentConfigData => {
	const hydratedData: ISegmentConfigData = {};
	hydratedData.segmentName = data.segmentName;
	hydratedData.expName = data.expName;
	hydratedData.bucketSupportedList = data.bucketSupportedList;
	hydratedData.conversionCoolOfPeriodHours = data.conversionCoolOfPeriodHours;
	hydratedData.conversionMinWithdrawalLimit = data.conversionMinWithdrawalLimit?.toLocaleString('en-IN');
	hydratedData.conversionMaxWithdrawalLimit = data.conversionMaxWithdrawalLimit?.toLocaleString('en-IN');
	hydratedData.withdrawalCoolOfPeriodHours = data.withdrawalCoolOfPeriodHours;
	hydratedData.minWithdrawalLimit = data.minWithdrawalLimit?.toLocaleString('en-IN');
	hydratedData.maxWithdrawalLimit = data.maxWithdrawalLimit?.toLocaleString('en-IN');
	hydratedData.globalCoolOfPeriodsInHours = data.globalCoolOfPeriodsInHours;
	hydratedData.minimumCommonCoolOffPeriodInHours = data.minimumCommonCoolOffPeriodInHours;
	hydratedData.enableMinimumCoolOffFlow = data.enableMinimumCoolOffFlow;
	hydratedData.withdrawalFeeRange = (data?.withdrawalFee?.range || []).map(
		(currentConfig: {
			range: {
				start: number;
				end: number;
			};
			percentage: number;
			flatValue: number;
		}) => {
			const filteredConfig: {
				withdrawalFeeFlatValue?: string;
				withdrawalFeePercentage?: number;
				withdrawalFeeEndRange?: string;
				withdrawalFeeStartRange?: string;
			} = {};
			filteredConfig.withdrawalFeeStartRange = currentConfig.range?.start?.toLocaleString('en-IN');
			filteredConfig.withdrawalFeeEndRange = currentConfig.range?.end?.toLocaleString('en-IN');
			filteredConfig.withdrawalFeePercentage = currentConfig.percentage || 0;
			filteredConfig.withdrawalFeeFlatValue = currentConfig.flatValue?.toLocaleString('en-IN') || '0';
			return filteredConfig;
		}
	);
	hydratedData.withdrawalFeeMaxValue = data?.withdrawalFee?.maxValue?.toLocaleString('en-IN');
	return hydratedData;
};

export const dehydrateFormData = (data: ISegmentConfigData): IConversionConfig => {
	const conversionConfig: IConversionConfig = { withdrawalFee: {} };
	const bucketSupportedList = data?.bucketSupportedList?.map((currentBucket: string) => currentBucket.replace(/\(.*\)/g, ''));
	conversionConfig.segmentName = data.segmentName;
	conversionConfig.expName = data.expName;
	conversionConfig.bucketSupportedList = bucketSupportedList;
	conversionConfig.conversionCoolOfPeriodHours = data.conversionCoolOfPeriodHours;
	conversionConfig.conversionMinWithdrawalLimit = Number(data?.conversionMinWithdrawalLimit?.replace(/,/g, ''));
	conversionConfig.conversionMaxWithdrawalLimit = Number(data?.conversionMaxWithdrawalLimit?.replace(/,/g, ''));
	conversionConfig.withdrawalCoolOfPeriodHours = data.withdrawalCoolOfPeriodHours;
	conversionConfig.minWithdrawalLimit = Number(data?.minWithdrawalLimit?.replace(/,/g, ''));
	conversionConfig.maxWithdrawalLimit = Number(data?.maxWithdrawalLimit?.replace(/,/g, ''));
	conversionConfig.globalCoolOfPeriodsInHours = data.globalCoolOfPeriodsInHours;
	conversionConfig.minimumCommonCoolOffPeriodInHours = data.minimumCommonCoolOffPeriodInHours;
	conversionConfig.enableMinimumCoolOffFlow = data.enableMinimumCoolOffFlow;
	if (!lodash.isEmpty(data?.withdrawalFeeRange)) {
		conversionConfig.withdrawalFee.range = data?.withdrawalFeeRange?.map(
			(currentConfig: {
				withdrawalFeeFlatValue?: string;
				withdrawalFeePercentage?: number;
				withdrawalFeeEndRange?: string;
				withdrawalFeeStartRange?: string;
			}) => {
				const filteredConfig: {
					range?: {
						start?: number;
						end?: number;
					};
					percentage?: number;
					flatValue?: number;
				} = {};
				filteredConfig.range = {
					start: Number(currentConfig?.withdrawalFeeStartRange?.replace(/,/g, ''))
				};
				if (Number(currentConfig?.withdrawalFeeEndRange?.replace(/,/g, '')))
					filteredConfig.range.end = Number(currentConfig?.withdrawalFeeEndRange?.replace(/,/g, ''));
				if (
					(Number(currentConfig?.withdrawalFeeFlatValue?.replace(/,/g, '')) || 0) === 0 &&
					(currentConfig.withdrawalFeePercentage || 0) === 0
				)
					filteredConfig.percentage = currentConfig.withdrawalFeePercentage;
				else if (currentConfig?.withdrawalFeePercentage && currentConfig.withdrawalFeePercentage > 0)
					filteredConfig.percentage = currentConfig.withdrawalFeePercentage;
				else if (Number(currentConfig?.withdrawalFeeFlatValue?.replace(/,/g, '')) > 0)
					filteredConfig.flatValue = Number(currentConfig?.withdrawalFeeFlatValue?.replace(/,/g, ''));
				return filteredConfig;
			}
		);
	}
	if (
		!lodash.isNil(data?.withdrawalFeeMaxValue) &&
		Number(data.withdrawalFeeMaxValue.replace(/,/g, '')) > 0 &&
		!lodash.isNil(conversionConfig.withdrawalFee)
	)
		conversionConfig.withdrawalFee.maxValue = Number(data.withdrawalFeeMaxValue.replace(/,/g, ''));
	return conversionConfig;
};
